module.exports = __webpack_public_path__ + "static/media/planticon.328c1774.png";